import { User } from 'features/auth';
import { Role } from 'features/auth/types';
import {
  omitSideMenuRoutes,
  omitSideMenuRoutesPatient
} from 'lib/constants/filters';

export function resolveRenderNavigation(user: User | null, location: string) {
  if (!user) return false;
  /**
   * Case 1: The user is not a patient
   */
  if (user.role !== Role.Patient) {
    return ![...omitSideMenuRoutes].find(match =>
      location.toLowerCase().includes(match.toLowerCase())
    );
  }
  /**
   * Case 2: The user is a patient
   */
  return !omitSideMenuRoutesPatient.find(match =>
    location.toLowerCase().includes(match.toLowerCase())
  );
}
